require('es6-promise').polyfill();
import axios from 'axios';
import Utilities from './utilities';

export default {
  addProductToCart (data, cb_success, cb_failure) {
    // debugger;
    axios.post(Utilities.apiURL() + 'cart', data)
      .then(function (response) {
        cb_success(response);
      })
      .catch(function (error) {
        cb_failure(error);
      });
  },

  getCart (visitor_id, module_id, cb_success, cb_failure) {
    axios.get(Utilities.apiURL() + 'cart' + '/' + visitor_id + '/' + module_id)
      .then(function (response) {
        cb_success(response);
      })
      .catch(function (error) {
        cb_failure(error);
      });
  },
  updateQuatity (payload, cb_success, cb_failure) {
    axios.put(Utilities.apiURL() + 'cart' + '/' + payload.cart_id, {'quantity': payload.quantity})
      .then(function (response) {
        cb_success(response);
      })
      .catch(function (error) {
        cb_failure(error);
      });
  },

  deleteCartItem (cart_id, cb_success, cb_failure) {
    axios.delete(Utilities.apiURL() + 'cart' + '/' + cart_id)
      .then(function (response) {
        cb_success(response);
      })
      .catch(function (error) {
        cb_failure(error);
      });
  },

  applyCoupon (module_id, visitor_id, code, cb_success, cb_failure) {
    axios.get(Utilities.apiURL() + 'coupon' + '/' + module_id + '/' + visitor_id + '/' + code)
      .then(function (response) {
        cb_success(response);
      })
      .catch(function (error) {
        cb_failure(error);
      });
  },

  removeCoupon (module_id, visitor_id, code, cb_success, cb_failure) {
    axios.delete(Utilities.apiURL() + 'coupon' + '/' + module_id + '/' + visitor_id + '/' + code)
      .then(function (response) {
        cb_success(response);
      })
      .catch(function (error) {
        cb_failure(error);
      });
  },

  shipping_list (module_id, cb_success, cb_failure = null) {
    return axios.get(Utilities.apiURL() + 'shipping/' + module_id).then((response) => {
      cb_success(response.data.data);
    }, (response) => {

    });
  },
};



// WEBPACK FOOTER //
// ./src/api/cart.js